export const COURSE_THEMES_API = '/api/dashboard/customer/membership/course-theme/list'
